import uploadClaimDocumentsForm from "form/modal/uploadClaimDocuments";
import { FORM_UPLOAD_CLAIM_DOCUMENTS } from "../constants";

export const ModalUploadClaimDocumentsForm = uploadClaimDocumentsForm.createContainer(FORM_UPLOAD_CLAIM_DOCUMENTS);
